<template>
    <div :class="$x.nsAddressFormWrapper">
        <div id="addressHeaderWrap" :class="$x.addressHeaderWrapper">
            <div id="addressHeader" :class="$x.addressHeader">
                {{ t.header }}
            </div>
            <div
                v-show="!showForm"
                id="editAddress"
                :class="$x.lnk"
                @click="editAddress"
            >
                {{ t.edit }}
            </div>
        </div>
        <div v-if="!showForm">
            <div v-if="marketSelection != 'jp'" id="mktForm" :class="$x.address">
                <div id="address1" :class="$x.addressLine">
                    {{ address.address1 }}
                </div>
                <div id="address2" class="address-line">
                    {{ address.address2 }}
                </div>
                <div v-show="address.district" id="district" :class="$x.addressLine">
                    {{ address.district }}
                </div>
                <div v-show="address.addressType != '7-11'" id="cityStZipCntry">
                    {{ address.city }}, {{ address.region }}, {{ address.postalCode }},
                    {{ address.country }}
                </div>
                <div v-show="address.email" id="email">
                    {{ address.email }}
                </div>
            </div>
            <div v-if="marketSelection == 'jp'" id="jpForm">
                <div id="zipRegion" :class="$x.addressLine">
                    {{ address.postalCode }} {{ address.region }}
                </div>
                <div id="city" :class="$x.addressLine">
                    {{ address.city }}
                </div>
                <div id="district" :class="$x.addressLine">
                    {{ address.district }}
                </div>
                <div id="address1">
                    {{ address.address1 }}
                </div>
                <div v-show="address.email" id="email">
                    {{ address.email }}
                </div>
            </div>
        </div>
        <div :class="{ [$x.hideElement]: !showForm }">
            <NsSelect
                v-if="!country"
                v-model="marketSelection"
                class="flex-column"
                name="countrySelect"
                :items="markets"
                :label="t.market"
                @input="marketChanged"
            ></NsSelect>
            <VForm ref="addressForm">
                <NsAddress
                    v-model="formAddress"
                    :lang="lang"
                    :country="marketSelection.toUpperCase()"
                    :include-email="includeEmail"
                    @new-address-in-form="validateNewAddress"
                ></NsAddress>
            </VForm>
            <div :class="$x.addressButtons">
                <button
                    class="hit-solid fluid form-save"
                    name="saveAddress"
                    @click="saveAddressHandler"
                >
                    {{ t.saveAddress }}
                </button>
                <button
                    class="hit-outline fluid"
                    name="cancelSaveAddress"
                    @click="cancelAddressForm"
                >
                    {{ t.cancel }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { VForm } from 'vuetify/lib';
import {NsSelect} from '@nuskin/design-components';
import NsAddress from './NsAddress.vue';

export default {
    name: 'NsAddressForm',
    components: {
        NsSelect,
        VForm,
        NsAddress,
    },
    props: {
        value: {
            type: Object,
            default() {
                return null;
            },
        },

        lang: {
            type: String,
            default() {
                return 'en';
            },
        },

        country: {
            type: String,
            default() {
                return '';
            },
        },

        editing: {
            type: Boolean,
            default() {
                return false;
            },
        },

        includeEmail: {
            type: Boolean,
            default: true,
        },

        enableAddressSuggest: {
            type: Boolean,
            default: false,
        },

        /**
     * Translations as a key:value object
     */
        translations: {
            type: Object,
            default() {
                return {
                    header: 'Billing Address',
                    edit: 'Edit',
                    saveAddress: 'Save Address',
                    cancel: 'Cancel',
                    market: 'Market',
                    fieldRequired: 'This field is required',
                };
            },
        },
    },
    data() {
        return {
            showForm: false,
            address: { initial: 'data' },
            formAddress: {},
            validateForm: false,
            markets: [
                { text: 'Argentina', value: 'ar' },
                { text: 'Australia', value: 'au' },
                { text: 'Austria', value: 'at' },
                { text: 'Belgium', value: 'be' },
                { text: 'Brunei', value: 'bn' },
                { text: 'Canada', value: 'ca' },
                { text: 'Chile', value: 'cl' },
                { text: 'Colombia', value: 'co' },
                { text: 'Czech Republic', value: 'cz' },
                { text: 'Denmark', value: 'dk' },
                { text: 'Finland', value: 'fi' },
                { text: 'France', value: 'fr' },
                { text: 'French Polynesia', value: 'pf' },
                { text: 'Germany', value: 'de' },
                { text: 'Hong Kong', value: 'hk' },
                { text: 'Hungary', value: 'hu' },
                { text: 'Iceland', value: 'is' },
                { text: 'Indonesia', value: 'id' },
                { text: 'Israel', value: 'il' },
                { text: 'Italy', value: 'it' },
                { text: 'Japan', value: 'jp' },
                { text: 'Malaysia', value: 'my' },
                { text: 'Mexico', value: 'mx' },
                { text: 'New Zealand', value: 'nz' },
                { text: 'Norway', value: 'no' },
                { text: 'Peru', value: 'pe' },
                { text: 'Philippines', value: 'ph' },
                { text: 'Poland', value: 'pl' },
                { text: 'Portugal', value: 'pt' },
                { text: 'Romania', value: 'ro' },
                { text: 'Russia', value: 'ru' },
                { text: 'Singapore', value: 'sg' },
                { text: 'Slovakia', value: 'sk' },
                { text: 'South Africa', value: 'za' },
                { text: 'Spain', value: 'es' },
                { text: 'Sweden', value: 'se' },
                { text: 'Switzerland', value: 'ch' },
                { text: 'Thailand', value: 'th' },
                { text: 'Turkey', value: 'tr' },
                { text: 'Ukraine', value: 'ua' },
                { text: 'United Kingdom', value: 'gb' },
                { text: 'United States', value: 'us' },
                { text: 'Vietnam', value: 'vn' },
            ],
            marketSelection: this.country,
            displayLines: [],
        };
    },

    computed: {
        t() {
            return this.translations;
        },
    },

    watch: {
        value() {
            if (this.value) {
                this.initValue();
            }
        },

        country() {
            if (this.country && this.country !== this.formAddress.country) {
                this.formAddress = { country: this.country };
            }
            this.showForm = !this.formAddress.address1;
            this.setMarketSelection();
        },

        editing() {
            if (this.editing) {
                this.showAddressForm();
            } else {
                this.cancelAddressForm();
            }
        },
    },

    mounted() {
        if (this.value) {
            this.initValue();
        }
    },

    methods: {
        initValue() {
            this.address = { ...this.value };
            this.setAddressInForm(this.value);
            if (this.address.address1) {
                this.validateForm = true;
            }
        },

        validateNewAddress() {
            if (this.validateForm) {
                const scope = this;
                const valid = scope.$refs.addressForm.validate();

                if (!valid) {
                    scope.showAddressForm();
                }
                scope.$emit('address-valid', valid);
                this.validateForm = false;
            }
        },

        validate() {
            this.validateForm = true;
            this.validateNewAddress();
            return this.$refs.addressForm.validate();
        },

        reset() {
            this.$refs.addressForm.reset();
        },

        setAddressInForm(formValues) {
            this.formAddress = { ...formValues };
            this.setMarketSelection(this.formAddress.country);
        },

        editAddress() {
            this.validateForm = false;
            this.$refs.addressForm.resetValidation();
            this.setAddressInForm(this.address);
            this.showAddressForm();
        },

        showAddressForm() {
            if (!this.showForm) {
                this.emitEditingAddress(true);
                this.showForm = true;
            }
        },

        saveAddressHandler() {
            const formValid = this.$refs.addressForm.validate();
            if (formValid) {
                if (this.enableAddressSuggest) {
                    this.$emit('address-suggest', this.formAddress);
                } else {
                    this.saveAddress();
                }
            }
        },

        saveAddress() {
            this.address = { ...this.formAddress };
            this.$emit('input', { ...this.address });
            this.emitEditingAddress(false);
            this.$emit('address-valid', true);
            this.showForm = false;
        },

        cancelAddressForm() {
            if (this.showForm) {
                this.validateForm = false;
                this.emitEditingAddress(false);
                this.showForm = false;
            }
        },

        setMarketSelection(formCountry = 'us') {
            this.marketSelection = this.country
                ? this.country.toLowerCase()
                : formCountry.toLowerCase();
        },

        marketChanged() {
            this.validateForm = false;
            this.$refs.addressForm.resetValidation();
            if (this.address.country === this.marketSelection.toUpperCase()) {
                this.formAddress = { ...this.address, showFormOnValidate: true };
            } else {
                this.formAddress = { country: this.marketSelection.toUpperCase() };
            }
        },

        emitEditingAddress(editing) {
            this.$emit('editing', editing);
        },
    },
};
</script>

<style lang="scss" module="$x">
@use "sass:map";
@use "~@nuskin/ns-core-styles/src/scss/colors";

.addressHeaderWrapper {
  display: flex;
  justify-content: space-between;
  font-size: larger;
  font-weight: bold;

  .lnk {
    color: map.get(colors.$baseColors, shells);
    cursor: pointer;
    text-transform: uppercase;
  }
}

.addressButtons {
  margin-top: 15px;
}
.formSave {
  margin-bottom: 15px;
}

.nsAddressForm {
  .dateField {
    max-width: 120px;
  }

  h2 {
    display: flex;
    justify-content: space-between;
    margin-bottom: 15px;
  }
}

.hideElement {
  height: 0;
  overflow: hidden;
}
</style>

<style lang="scss" scoped>
@use "sass:map";
@use "~@nuskin/ns-core-styles/src/scss/typographyVariables";

*:not(.v-icon) {
  font-family: map.get(typographyVariables.$typography, 'font-family-primary');
}
</style>

<style lang="scss">
@use "sass:map";
@use "~@nuskin/ns-core-styles/src/scss/vuetifyOverrides";
@use "~@nuskin/ns-core-styles/src/scss/colors";

#mainContainer {
  a.v-list__tile,
  a.v-list__tile:hover,
  a.v-list__tile:active {
    align-content: center;
    color: inherit;
    display: flex;
    font-size: 16px;
    font-weight: 400;
    height: 48px;
    margin: 0;
    padding: 0 16px;
    position: relative;
    text-decoration: none;
    -webkit-transition: background 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
    transition: background 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
    text-transform: none;
  }
}
::v-deep {
  input:focus {
    border: 1px solid map.get(colors.$theme, 'accent-color-b') !important;
  }
}
</style>
